export const changeAccountStatusBulkActionType = 'changeAccountStatus';
